import { FONT } from "../../../value/staticValues";
import BackupAdd from "./BackupAdd";
import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";
import i18n from "../../../lang/base";
import { parseLocaleDatetime } from "common/util";
import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";


import { ReactComponent as DownloadImg } from "../../../img/ico-quick-download-normal.svg";
import BackupRestore from "./BackupRestore";
import { DropdownType } from "components/base/CustomDropdown";


export const categoryFilters:ListFilter[] = [];


export interface VmBackupData {
    vm_backup_id: string;
    vm_backup_name: string;
    vm_backup_description: string;
    vm_backup_status_code: string;
    vm_name: string;
    vm_backup_filename: string;
    os_type_code: string;
    real_size_mb: number;
    virt_size_mb: number;
    backup_image_file_exists_yn: boolean;
    vm_type_name: string;
    vm_image_name: string;
    vm_key_pair_name: string;
    create_ts: string;
    update_ts: string;
    project: {
        project_id: string;
        project_name: string;
    },
    backup_storage: {
        backup_storage_id: string;
        backup_storage_name: string;
        mount_path: string;
    }
}


export const initVmBackupData = {
    vm_backup_id: '',
    vm_backup_name: '',
    vm_backup_description: '',
    vm_backup_status_code: '',
    vm_name: '',
    vm_backup_filename: '',
    os_type_code: '',
    real_size_mb: 0,
    virt_size_mb: 0,
    backup_image_file_exists_yn: false,
    vm_type_name: '',
    vm_image_name: '',
    vm_key_pair_name: '',
    create_ts: '',
    update_ts: '',
    project: {
        project_id: '',
        project_name: '',
    },
    backup_storage: {
        backup_storage_id: '',
        backup_storage_name: '',
        mount_path: '',
    }
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("BACKUP_IMEAGE_CREATION_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "BACKUP_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("백업 이미지 다운로드"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: false,

        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "BACKUP_IMAGE_DOWNLOAD",
            imgComponent: <DownloadImg style={{width: 20, height: 20}}/> ,
            activeImgComponent:<DownloadImg style={{width: 20, height: 20}}/>,
            inactiveImgComponent: <DownloadImg style={{width: 20, height: 20, filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 3,
        name: i18n.t("DELETED_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "BACKUP_DELETE",
        },
    },
    {
        id: 4,
        name: i18n.t("가져오기/내보내기"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "BACKUP_RESTORE",
        },
    },
    {
        id: 5,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "SYNC"
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("VM_BACKUP_IMAGE_NAME"),
        accessor: "vm_backup_name",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value: '-'}</div>)
    },
    {
        Header: i18n.t("VM_BACKUP_IMAGE_FILE_NAME"),
        accessor: "vm_backup_filename",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#5c5c5c"}}>{value ? value: '-'}</div>)
    },
    {
        Header: i18n.t("VM_BACKUP_IMAGE_STATUS"),
        accessor: "vm_backup_status_code",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
               {
                    (() => {
                        if(value === "AVB")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#3a8344"}}>
                                <ActiveImg style={className.statusImg}/> <>{i18n.t("AVAIL_TEXT")}</>
                            </div>)
                        else if(value === "CRT")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#0853fb"}}>
                                <IdleImg style={className.statusImg}/><>{i18n.t("CREATING_TEXT")}</>
                            </div>)
                        else if(value === "IMP")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#7066f1"}}>
                                <IdleImg style={className.statusImg}/><>{i18n.t("DOWNLOADING_TEXT")}</>
                            </div>)
                        else if(value === "NO_EXIST")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#e6735c"}}>
                                <ErrorImg style={className.statusImg}/><>{i18n.t("NO_EXIST_TEXT")}</>
                            </div>)
                        else
                            return (
                                <div style={{...className.statusInnerContainer, color:"#e86045"}}>
                                <ErrorImg style={className.statusImg}/><>{i18n.t("UNAVAIL_TEXT")}</>
                            </div>)
                    })()
                }
            </div>
        )
    },
    {
        Header: i18n.t("VM_BASE_IMAGE_TEXT"),
        accessor: "vm_image_name",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value: '-'}</div>)
    },
    {
        Header: i18n.t("INSTANCE_TYPE_NAME_TEXT"),
        accessor: "vm_type_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value: '-'}</div>)
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value?.project_name ? value.project_name : '-'}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
];

export const backupAddModalContent = {
    title: i18n.t("BACKUP_IMEAGE_CREATION_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <BackupAdd />,
}

export const backupRestoreModalContent = {
    title: i18n.t("BACKUP_IMEAGE_RESTORE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("RESTORE_TEXT")
        },
    ],
    innerComponent: <BackupRestore />,
}

export const storageProtocolDropdownItem:DropdownType[] = [
    {
        value: "SFTP",
        label: "SFTP"
    },
    // {
    //     value: "NFS",
    //     label: "NFS"
    // },
    // {
    //     value: "HTTP",
    //     label: "HTTP"
    // },
    // {
    //     value: "HTTPS",
    //     label: "HTTPS"
    // },
]
const className = {
    rowContainer: {
        width: "100%"
    },
    statusContainer: {
        width: "100px",
        display: "flex",
        alignItems: "center",
    },
    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#9ea0a5",
        overflow: "hidden"
    },
    usageTypeContainerService: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#5b9782",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
    usageTypeContainerContNode: {
        width: 120, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#f5ddd0",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#cc7e52",
    },
    usageTypeContainerManagement: {
        width: 90, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#fbefc9",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#92782f",
    },
    usageTypeContainerUnknown: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#c1c7cc",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
}